// 系統設定: 公司資料 / 帳號 / 付款條款 / 保障條款範本
import React, { useEffect, useRef, useState } from 'react';
import { api, auth } from '../api.js';
import { Modal, Field, Loading, PageHead, useToast, useConfirm } from '../ui.jsx';

/* ---------- SMTP 出街設定 ---------- */
function AccountSMTP() {
  const { toast } = useToast();
  const [f, setF] = useState({ smtp_host: '', smtp_port: '587', smtp_user: '', smtp_from: '', smtp_pass: '' });
  const [meta, setMeta] = useState(null);
  const load = () => api.get('/smtp-config').then(c => { setMeta(c); setF(x => ({ ...x, smtp_host: c.host, smtp_port: c.port || '587', smtp_user: c.user, smtp_from: c.from })); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const save = async () => {
    try { await api.put('/smtp-config', f); toast('SMTP 已儲存 ✔ 之後 Email 發送全自動 (PDF 附件直送)'); load(); }
    catch (e) { toast(e.message, 'err'); }
  };
  return (
    <div>
      <p className="muted" style={{ marginBottom: 10 }}>設定 SMTP 之後，所有「✉️ Email」掣會直接由伺服器发送（PDF 附件直入客戶郵箱），唔使再開 mailto。Gmail 範例：smtp.gmail.com / 587 / 你的 Gmail / <a href="https://myaccount.google.com/apppasswords" target="_blank" rel="noreferrer">App Password</a>（16碼）。</p>
      <div className="form-grid">
        <div className="field"><label>SMTP Host</label><input className="input" placeholder="smtp.gmail.com" value={f.smtp_host} onChange={e => set('smtp_host', e.target.value)} /></div>
        <div className="field"><label>Port (587 / 465)</label><input className="input" value={f.smtp_port} onChange={e => set('smtp_port', e.target.value)} /></div>
        <div className="field"><label>帳號 User</label><input className="input" placeholder="stephenwong@ashserviceco.com" value={f.smtp_user} onChange={e => set('smtp_user', e.target.value)} /></div>
        <div className="field"><label>密碼 / App Password {meta && meta.pass_set ? '(已設定 ✓)' : ''}</label><input className="input" type="password" placeholder={meta && meta.pass_set ? '•••••• (留空 = 不變)' : 'App Password'} value={f.smtp_pass} onChange={e => set('smtp_pass', e.target.value)} /></div>
        <div className="field"><label>寄件者 From (可留空)</label><input className="input" value={f.smtp_from} onChange={e => set('smtp_from', e.target.value)} /></div>
      </div>
      <div className="row end"><button className="btn primary" onClick={save}>💾 儲存 SMTP</button></div>
    </div>
  );
}

/* ---------- Agent / Hermes 接入管理 ---------- */
function AccountAgent() {
  const { toast } = useToast();
  const [keys, setKeys] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [newName, setNewName] = useState('');
  const [out, setOut] = useState({ outbound_mode: 'off', outbound_url: '' });
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const load = () => {
    api.get('/agent/keys').then(setKeys).catch(() => setKeys([]));
    api.get('/agent/hermes-config').then(c => { setCfg(c); setOut({ outbound_mode: c.outbound_mode || 'off', outbound_url: c.outbound_url || '' }); }).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const createKey = async () => {
    try { const r = await api.post('/agent/keys', { name: newName || 'Agent' }); toast('金鑰已建立 — 複製後妥善保存，只顯示一次'); setNewName(''); load(); setTimeout(() => { const row = document.getElementById('k' + r.id); if (row) navigator.clipboard && navigator.clipboard.writeText(r.key); }, 300); }
    catch (e) { toast(e.message, 'err'); }
  };
  const saveOut = async () => {
    try { await api.put('/agent/hermes-config', out); toast('Hermes 出街設定已儲存 ✔'); load(); } catch (e) { toast(e.message, 'err'); }
  };

  if (!cfg) return null;
  return (
    <div>
      <p className="muted" style={{ marginBottom: 10 }}>令外部 bot / AI agent (例如 Hermes) 接入 Skycrafter 天神村：① 用 API 金鑰行全套 API ② WhatsApp 查詢指令經 Webhook 入嚟 ③ 設定 Hermes API 後系統自動出 WhatsApp。</p>

      <div className="row mb" style={{ background: 'var(--surface-soft)', border: '1px dashed var(--line)', borderRadius: 12, padding: 12, alignItems: 'center' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 800, fontSize: 12.5 }}>Webhook 指令入口 (俾 Hermes 收到訊息時轉發過嚟)</div>
          <div className="muted" style={{ fontSize: 11.5, marginTop: 3, wordBreak: 'break-all' }}>{origin}/api/hooks/hermes</div>
          <div className="muted" style={{ fontSize: 11.5 }}>Secret: <b>{cfg.webhook_secret}</b></div>
          <div className="muted" style={{ fontSize: 11 }}>指令: 欠款 [客戶名] / 提醒 / 工程 / 發票 編號 / help</div>
          <div className="muted" style={{ fontSize: 11, marginTop: 4 }}>Secret 傳法 (4 選 1): Header <b>X-Hermes-Secret</b> / <b>Authorization: Bearer</b> / URL <b>?secret=</b> / Body 欄位 <b>secret</b> — 必須用 <b>https://</b></div>
        </div>
        <button className="btn sm primary" onClick={async () => {
          try {
            const r = await api.get('/hooks/hermes?secret=' + encodeURIComponent(cfg.webhook_secret));
            toast('✅ Webhook 連線正常: ' + (r.service || 'OK'));
          } catch (e) { toast('❌ 測試失敗: ' + e.message, 'err'); }
        }}>🧪 測試連線</button>
      </div>

      <div className="card-title" style={{ marginBottom: 8, fontSize: 13.5 }}>🔑 API 金鑰 ({(keys || []).length})</div>
      {(keys || []).map(k => (
        <div key={k.id} className="row" style={{ justifyContent: 'space-between', fontSize: 12.5, padding: '7px 10px', borderBottom: '1px dashed var(--line)' }}>
          <span><b>{k.name}</b> <span className="muted">{k.key.slice(0, 10)}…</span></span>
          <button className="btn sm coral" onClick={async () => { try { await api.del('/agent/keys/' + k.id); toast('已刪除 (即刻失效)'); load(); } catch (e) { toast(e.message, 'err'); } }}>🗑️</button>
        </div>
      ))}
      <div className="row mt mb">
        <input className="input" style={{ flex: 1, maxWidth: 260 }} placeholder="金鑰名稱 (例如 Hermes Bot)" value={newName} onChange={e => setNewName(e.target.value)} />
        <button className="btn sm primary" onClick={createKey}>➕ 建立金鑰</button>
      </div>

      <div className="card-title" style={{ marginBottom: 8, fontSize: 13.5 }}>📤 出街接口 (Hermes 自動發 WhatsApp)</div>
      <div className="form-grid">
        <Field label="模式">
          <select className="select" value={out.outbound_mode} onChange={e => setOut({ ...out, outbound_mode: e.target.value })}>
            <option value="off">關閉 (用 wa.me 手動掣)</option>
            <option value="api">API 模式 (全自動)</option>
          </select>
        </Field>
        <Field label="Hermes API URL" span2>
          <input className="input" placeholder="https://hermes…/send?phone={phone}&text={text}" value={out.outbound_url} onChange={e => setOut({ ...out, outbound_url: e.target.value })} />
        </Field>
      </div>
      <div className="row end"><button className="btn primary" onClick={saveOut}>💾 儲存出街設定</button></div>
      <p className="muted" style={{ marginTop: 8 }}>Token 已設定: {cfg.outbound_token_set ? '✅' : '❌ (聯絡開發者配置)'} — 設定好後, 每日提醒同 Statement 可以直接自動 WhatsApp 出街。</p>
    </div>
  );
}

/* ---------- 我的帳號 / 帳號管理 ---------- */
function AccountSection() {
  const { toast } = useToast();
  const [confirm, confirmNode] = useConfirm();
  const me = auth.user;
  const [pw, setPw] = useState({ old_password: '', new_password: '', confirm: '' });
  const [users, setUsers] = useState(null);
  const [nu, setNu] = useState({ username: '', display_name: '', password: '', role: 'user' });
  const isAdmin = me?.role === 'admin';

  const loadUsers = () => { if (isAdmin) api.get('/users').then(setUsers).catch(() => setUsers([])); };
  useEffect(() => { loadUsers(); }, []);

  const changePw = async () => {
    if (pw.new_password !== pw.confirm) return toast('兩次新密碼不一致', 'err');
    if ((pw.new_password || '').length < 6) return toast('新密碼至少要 6 個字', 'err');
    try {
      await api.put('/auth/password', { old_password: pw.old_password, new_password: pw.new_password });
      toast('密碼已更新 ✔');
      setPw({ old_password: '', new_password: '', confirm: '' });
    } catch (e) { toast(e.message, 'err'); }
  };
  const addUser = async () => {
    try { await api.post('/users', nu); toast(`帳號 ${nu.username} 已建立 ✔`); setNu({ username: '', display_name: '', password: '', role: 'user' }); loadUsers(); }
    catch (e) { toast(e.message, 'err'); }
  };
  const delUser = (u) => confirm(`刪除帳號「${u.display_name || u.username}」？佢會即時被登出。`, async () => {
    try { await api.del(`/users/${u.id}`); toast('已刪除'); loadUsers(); } catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });

  return (
    <>
      <div className="card">
        <div className="card-title"><span className="ico-badge violet" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>👤</span>我的帳號 — {me?.display_name || me?.username}</div>
        <div className="form-grid">
          <Field label="舊密碼"><input className="input" type="password" value={pw.old_password} onChange={e => setPw({ ...pw, old_password: e.target.value })} /></Field>
          <Field label="新密碼 (至少 6 個字)"><input className="input" type="password" value={pw.new_password} onChange={e => setPw({ ...pw, new_password: e.target.value })} /></Field>
          <Field label="確認新密碼"><input className="input" type="password" value={pw.confirm} onChange={e => setPw({ ...pw, confirm: e.target.value })} /></Field>
        </div>
        <div className="row end mt"><button className="btn primary" onClick={changePw}>🔑 更改密碼</button></div>
      </div>

      {isAdmin ? (
        <div className="card">
          <div className="card-title"><span className="ico-badge sky" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>👥</span>帳號管理 (同事登入帳號)</div>
          <div className="tbl-wrap">
            <table className="tbl">
              <thead><tr><th>帳號</th><th>名稱</th><th>角色</th><th></th></tr></thead>
              <tbody>
                {(users || []).map(u => (
                  <tr key={u.id}>
                    <td className="strong">{u.username}</td>
                    <td>{u.display_name}</td>
                    <td><span className={`st ${u.role === 'admin' ? 'st-violet' : 'st-gray'}`}>{u.role === 'admin' ? '👑 管理員' : '使用者'}</span></td>
                    <td>{u.id !== me.id ? <button className="btn sm coral" onClick={() => delUser(u)}>🗑️ 刪除</button> : <span className="st st-blue">我自己</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="form-grid mt">
            <Field label="登入帳號" required><input className="input" value={nu.username} onChange={e => setNu({ ...nu, username: e.target.value })} placeholder="例如: kenneth" /></Field>
            <Field label="顯示名稱"><input className="input" value={nu.display_name} onChange={e => setNu({ ...nu, display_name: e.target.value })} placeholder="例如: 陳大文" /></Field>
            <Field label="密碼 (至少 6 個字)" required><input className="input" type="password" value={nu.password} onChange={e => setNu({ ...nu, password: e.target.value })} /></Field>
            <Field label="角色">
              <select className="select" value={nu.role} onChange={e => setNu({ ...nu, role: e.target.value })}>
                <option value="user">使用者</option>
                <option value="admin">管理員 (可管理帳號)</option>
              </select>
            </Field>
          </div>
          <div className="row end mt"><button className="btn primary" onClick={addUser}>➕ 新增帳號</button></div>
        </div>
      ) : null}
      {confirmNode}
      <AuditLog />
      
    </>
  );
}

function TermEditor({ initial, onClose, onSaved }) {
  const { toast } = useToast();
  const isNew = !initial?.id;
  const [f, setF] = useState({
    name: initial?.name || '', description: initial?.description || '', is_default: initial?.is_default || false,
    installments: initial?.installments?.length ? initial.installments : [{ label: '全數', percent: 100, due_days: 30 }],
  });
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const updIns = (i, k, v) => setF(x => ({ ...x, installments: x.installments.map((t, ti) => ti === i ? { ...t, [k]: k === 'label' ? v : Number(v) } : t) }));
  const pctSum = f.installments.reduce((s, x) => s + (Number(x.percent) || 0), 0);
  const save = async () => {
    if (!f.name.trim()) return toast('請填寫條款名稱', 'err');
    if (Math.abs(pctSum - 100) > 0.01) return toast(`分期百分比合計必須是 100% (目前 ${pctSum}%)`, 'err');
    try {
      if (isNew) await api.post('/payment-terms', f); else await api.put(`/payment-terms/${initial.id}`, f);
      toast('付款條款已儲存 ✔'); onSaved();
    } catch (e) { toast(e.message, 'err'); }
  };
  return (
    <Modal onClose={onClose} icon="💳" title={isNew ? '➕ 新增付款條款' : `✏️ 編輯付款條款 — ${initial.name}`}
      footer={<><button className="btn" onClick={onClose}>取消</button><button className="btn primary" onClick={save}>💾 儲存</button></>}>
      <div className="form-grid mb">
        <Field label="條款名稱" required><input className="input" value={f.name} onChange={e => set('name', e.target.value)} placeholder="例如: 50% 訂金 / 50% 完工" /></Field>
        <Field label="說明"><input className="input" value={f.description} onChange={e => set('description', e.target.value)} /></Field>
      </div>
      <label className="row mb" style={{ gap: 6, fontSize: 13, fontWeight: 700 }}>
        <input type="checkbox" checked={!!f.is_default} onChange={e => set('is_default', e.target.checked)} /> 設為預設條款
      </label>
      <div className="card-title" style={{ marginBottom: 8 }}>分期設定 (合共 100%)</div>
      {f.installments.map((ins, i) => (
        <div key={i} className="row mb" style={{ alignItems: 'center', background: 'var(--surface-soft)', padding: 10, borderRadius: 12, border: '1px solid var(--line)' }}>
          <input className="input" style={{ flex: 1.4 }} placeholder="說明 (訂金/尾數)" value={ins.label} onChange={e => updIns(i, 'label', e.target.value)} />
          <input className="input num-input" style={{ width: 100 }} type="number" placeholder="%" value={ins.percent} onChange={e => updIns(i, 'percent', e.target.value)} />
          <span style={{ color: 'var(--ink-3)', fontWeight: 700 }}>%</span>
          <input className="input num-input" style={{ width: 120 }} type="number" placeholder="到期日+" value={ins.due_days} onChange={e => updIns(i, 'due_days', e.target.value)} />
          <span style={{ color: 'var(--ink-3)', fontWeight: 700 }}>日</span>
          <button className="btn sm coral" onClick={() => setF(x => ({ ...x, installments: x.installments.filter((_, xi) => xi !== i) }))}>✕</button>
        </div>
      ))}
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <button className="btn sm" onClick={() => setF(x => ({ ...x, installments: [...x.installments, { label: '', percent: 0, due_days: 30 }] }))}>➕ 分期</button>
        <span className={`st ${Math.abs(pctSum - 100) < 0.01 ? 'st-green' : 'st-red'}`}>合計 {pctSum}%</span>
      </div>
    </Modal>
  );
}

export default function Settings() {
  const { toast } = useToast();
  const [confirm, confirmNode] = useConfirm();
  const logoRef = useRef(null);
  const chop1Ref = useRef(null);
  const chop2Ref = useRef(null);
  const [s, setS] = useState(null);
  const [terms, setTerms] = useState(null);
  const [tpls, setTpls] = useState(null);
  const [termEdit, setTermEdit] = useState(null);
  const [newTpl, setNewTpl] = useState('');
  const refresh = () => {
    api.get('/settings').then(setS);
    api.get('/payment-terms').then(setTerms);
    api.get('/remark-templates').then(setTpls);
  };
  useEffect(() => { refresh(); }, []);
  if (!s || terms === null || tpls === null) return <Loading />;
  const set = (k, v) => setS(x => ({ ...x, [k]: v }));
  const save = async () => { try { await api.put('/settings', s); toast('公司資料已儲存 ✔'); } catch (e) { toast(e.message, 'err'); } };
  const pickImage = (key, label) => (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (!/^image\//.test(file.type)) return toast(`請選擇圖片檔 (PNG/JPG) — ${label}`, 'err');
    if (file.size > 1200 * 1024) return toast(`${label} 檔案太大 (請 1.2MB 內)`, 'err');
    const rd = new FileReader();
    rd.onload = () => { set(key, rd.result); toast(`${label} 已載入 — 撳「儲存公司資料」生效`); };
    rd.readAsDataURL(file);
  };
  const pickLogo = pickImage('company_logo', 'LOGO');
  const pickChop1 = pickImage('company_chop1', '印章 1');
  const pickChop2 = pickImage('company_chop2', '印章 2');
  const delTerm = (t) => confirm(`刪除付款條款「${t.name}」？`, async () => {
    try { await api.del(`/payment-terms/${t.id}`); toast('已刪除'); refresh(); } catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });
  const addTpl = async () => {
    if (!newTpl.trim()) return;
    try { await api.post('/remark-templates', { text: newTpl.trim() }); setNewTpl(''); toast('條款已加入'); refresh(); } catch (e) { toast(e.message, 'err'); }
  };
  const delTpl = (t) => confirm(`刪除條款範本？`, async () => {
    try { await api.del(`/remark-templates/${t.id}`); refresh(); } catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });

  return (
    <div>
      <PageHead icon="⚙️" title="系統設定" desc="帳號 · 公司資料 (印在 PDF 上) · 付款條款 · 保障條款範本" />
      <AccountSection />
      <div className="card">
        <div className="card-title"><span className="ico-badge" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>🏢</span>公司資料</div>
        <div className="form-grid">
          <Field label="公司名稱 (中英)" required span2><input className="input" value={s.company_name || ''} onChange={e => set('company_name', e.target.value)} /></Field>
          <Field label="公司 LOGO (印在所有 PDF 左上角)" span2>
            <div className="row">
              {s.company_logo
                ? <img src={s.company_logo} alt="logo" style={{ height: 52, background: '#f4f6fa', borderRadius: 10, padding: 6, border: '1px solid var(--line)' }} />
                : <span className="muted" style={null}>未上傳 (PDF 會用色塊代號)</span>}
              <input ref={logoRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={pickLogo} />
              <button className="btn sm primary" onClick={() => logoRef.current && logoRef.current.click()}>📎 上傳 LOGO</button>
              {s.company_logo ? <button className="btn sm coral" onClick={() => set('company_logo', '')}>移除</button> : null}
              <span className="muted">建議 PNG 透明底 · 1.2MB 內</span>
            </div>
          </Field>
          <Field label={`LOGO 顯示高度 (現時 ${s.company_logo_height || 160}px — 較大就搵眼啲)`}>
            <div className="row">
              <input type="range" min="80" max="280" step="10" value={s.company_logo_height || 160}
                onChange={e => set('company_logo_height', e.target.value)} style={{ flex: 1, accentColor: '#2f6bff' }} />
              <span className="strong" style={{ minWidth: 48, textAlign: 'right' }}>{s.company_logo_height || 160}px</span>
            </div>
          </Field>
          {[['company_chop1', '公司印章 1', chop1Ref, pickChop1], ['company_chop2', '公司印章 2', chop2Ref, pickChop2]].map(([key, label, ref, picker]) => (
            <Field key={key} label={`${label} (我方簽署印章 — QUOTATION / INVOICE / STATEMENT)`}>
              <div className="row">
                {s[key]
                  ? <img src={s[key]} alt={label} style={{ height: 56, background: '#fff', borderRadius: 8, padding: 3, border: '1px solid var(--line)' }} />
                  : <span className="muted">未設定</span>}
                <input ref={ref} type="file" accept="image/*" style={{ display: 'none' }} onChange={picker} />
                <button className="btn sm primary" onClick={() => ref.current && ref.current.click()}>📎 上傳</button>
                {s[key] ? <button className="btn sm coral" onClick={() => set(key, '')}>移除</button> : null}
                <span className="muted">PNG 透明底最佳</span>
              </div>
            </Field>
          ))}
          <Field label="地址"><input className="input" value={s.company_address || ''} onChange={e => set('company_address', e.target.value)} /></Field>
          <Field label="公司口號 (印在 PDF 頁尾右下)"><input className="input" value={s.company_tagline || ''} onChange={e => set('company_tagline', e.target.value)} placeholder="We do a lot more than introducing clean air into a space." /></Field>
          <Field label="簽署人 (Yours Sincerely 之下嘅名)"><input className="input" value={s.company_signatory || ''} onChange={e => set('company_signatory', e.target.value)} placeholder="Mr. Stephen WONG" /></Field>
          <Field label="電話"><input className="input" value={s.company_phone || ''} onChange={e => set('company_phone', e.target.value)} /></Field>
          <Field label="傳真"><input className="input" value={s.company_fax || ''} onChange={e => set('company_fax', e.target.value)} /></Field>
          <Field label="Email"><input className="input" value={s.company_email || ''} onChange={e => set('company_email', e.target.value)} /></Field>
          <Field label="商業登記"><input className="input" value={s.company_br || ''} onChange={e => set('company_br', e.target.value)} /></Field>
          <Field label="報價有效期 (日)"><input className="input num-input" type="number" value={s.default_valid_days || '30'} onChange={e => set('default_valid_days', e.target.value)} /></Field>
          <Field label="單據尾註"><input className="input" value={s.footer_note || ''} onChange={e => set('footer_note', e.target.value)} /></Field>
        </div>
        <div className="row end mt"><button className="btn primary" onClick={save}>💾 儲存公司資料</button></div>
      </div>

      <div className="card">
        <div className="card-title"><span className="ico-badge mint" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>💳</span>付款條款 Payment Terms
          <span className="spacer" /><button className="btn sm primary" onClick={() => setTermEdit({})}>➕ 新增條款</button></div>
        <div className="tbl-wrap">
          <table className="tbl">
            <thead><tr><th>名稱</th><th>說明</th><th>分期</th><th>預設</th><th></th></tr></thead>
            <tbody>
              {terms.map(t => (
                <tr key={t.id}>
                  <td className="strong">{t.name}</td>
                  <td className="sub">{t.description}</td>
                  <td>{t.installments.map(i => `${i.label} ${i.percent}%(${i.due_days}日)`).join(' · ')}</td>
                  <td>{t.is_default ? <span className="st st-blue">預設</span> : ''}</td>
                  <td>
                    <div className="row" style={{ flexWrap: 'nowrap' }}>
                      <button className="btn sm" onClick={() => setTermEdit(t)}>✏️</button>
                      <button className="btn sm coral" onClick={() => delTerm(t)}>🗑️</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card">
        <div className="card-title"><span className="ico-badge violet" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>📤</span>Email 出街 (SMTP)</div>
        <AccountSMTP />
      </div>

      <div className="card">
        <div className="card-title"><span className="ico-badge sky" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>🤖</span>Agent / Hermes 接入</div>
        <AccountAgent />
      </div>

      <div className="card">
        <div className="card-title"><span className="ico-badge coral" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>🛡️</span>保障條款範本 (REMARKS)</div>
        {tpls.map(t => (
          <div key={t.id} className="row" style={{ justifyContent: 'space-between', alignItems: 'center', padding: '9px 12px', borderRadius: 11, background: 'var(--surface-soft)', border: '1px solid var(--line)', marginBottom: 8 }}>
            <span style={{ fontSize: 13, color: 'var(--ink-2)', flex: 1, lineHeight: 1.5 }}>{t.text}</span>
            <button className="btn sm coral" onClick={() => delTpl(t)}>🗑️</button>
          </div>
        ))}
        <div className="row">
          <input className="input" style={{ flex: 1 }} placeholder="新增保障條款範本…" value={newTpl} onChange={e => setNewTpl(e.target.value)} onKeyDown={e => e.key === 'Enter' && addTpl()} />
          <button className="btn primary" onClick={addTpl}>➕ 加入</button>
        </div>
      </div>
      {termEdit && <TermEditor initial={termEdit.id ? termEdit : {}} onClose={() => setTermEdit(null)} onSaved={() => { setTermEdit(null); refresh(); }} />}
      {confirmNode}
    </div>
  );
}

/* ===== 審計日誌 — 邊個 幾時 改咗乜 ===== */
export function AuditLog() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get('/audit-logs?limit=200').then(setRows).catch(() => setRows([])); }, []);
  return (
    <div className="card mt">
      <div className="card-title"><span className="ico-badge" style={{ width: 28, height: 28, fontSize: 13, borderRadius: 8 }}>📜</span>審計日誌 Audit Log — 最近 200 筆改動</div>
      {rows === null ? <Loading /> : rows.length === 0 ? <p className="muted" style={{ padding: 14 }}>未有紀錄</p> : (
        <div className="tbl-wrap" style={{ maxHeight: 420, overflowY: 'auto' }}>
          <table className="tbl">
            <thead><tr><th>時間</th><th>用戶</th><th>操作</th><th>路徑</th><th>內容</th></tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td className="sub" style={{ whiteSpace: 'nowrap' }}>{(r.ts || '').replace('T', ' ').slice(0, 19)}</td>
                  <td className="strong">{r.user}</td>
                  <td><span className={'st ' + (r.method === 'DELETE' ? 'st-red' : r.method === 'POST' ? 'st-green' : 'st-gray')}>{r.method}</span></td>
                  <td className="sub" style={{ fontSize: 12 }}>{r.path}</td>
                  <td className="sub" style={{ fontSize: 12, maxWidth: 380, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.detail}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
